import React, { useState, useMemo } from 'react';
import {
  TextField,
  Datagrid,
  ChipField,
  ArrayField,
  SingleFieldList,
  ReferenceManyField,
  Pagination,
  FunctionField,
  BooleanField,
  SimpleShowLayout,
  useGetRecordId,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { Box, FormControlLabel, Switch, Grid } from '@mui/material';
import LinkField from 'components/LinkField';
import QuickCreateButton from 'components/QuickCreateButton';
import EnumSelectInput from 'components/Enum/EnumSelectInput';
import ProfessionalInput from 'components/ProfessionalInput';
import IdField from 'components/IdField';
import ScreenRequestsField from 'resources/assignments/ScreenRequestsField';
import { ProfessionalDisplayHelper } from 'utils/displayHelpers/professional';
import parentLink from 'resources/professionals/ParentLink';

const PermanentPlacementApplicationsTab = ({ canManage }) => {
  const [submittedToVMS, setSubmitted] = useState(false);
  const id = useGetRecordId();
  const filter = useMemo(
    () => ({ submitted_to_vms: submittedToVMS || undefined }),
    [submittedToVMS],
  );
  return (
    <SimpleShowLayout>
      {canManage && (
        <Box display="flex" justifyContent="space-between" my={3}>
          <QuickCreateButton initialValues={{ assignment_id: id }} resource="PermanentRequest">
            <ProfessionalInput />
            <EnumSelectInput resource="AssignmentRequest" source="status" />
          </QuickCreateButton>
          <FormControlLabel
            control={
              <Switch
                checked={submittedToVMS}
                onChange={(e) => setSubmitted(e.target.checked)}
                name="antoine"
              />
            }
            label="Submitted to VMS"
          />
        </Box>
      )}

      <ReferenceManyField
        label=""
        pagination={<Pagination />}
        reference="PermanentRequest"
        target="assignment_id"
        filter={filter}
      >
        <Datagrid bulkActionButtons={false}>
          <IdField resource="PermanentRequest" />
          <LinkField label="Professional ID" source="professional_id" typename="Professional" />
          <TextField label="Professional Name" source="professional.account.name" />
          <TextField label="Professional Phone Number" source="professional.account.phone_number" />
          <ArrayField label="Professional Markets" source="professional.markets">
            <SingleFieldList linkType={false}>
              <ChipField source="display_name" />
            </SingleFieldList>
          </ArrayField>
          <FunctionField
            label="Professional Type"
            render={(r) => {
              return (
                <Grid container direction="column">
                  <Grid item>{new ProfessionalDisplayHelper(r.professional).type}</Grid>
                  <Grid item>{parentLink(r.professional)}</Grid>
                </Grid>
              );
            }}
          />
          <FunctionField
            label="Recruiter"
            render={(r) =>
              r.professional.recruiter &&
              r.professional.recruiter.account && (
                <Link to={`/Administrator/${r.professional.recruiter_id}/show`}>
                  {r.professional.recruiter.account.name}
                </Link>
              )
            }
          />
          <TextField label="Patient Population" source="patient_population" />
          <TextField label="Status" source="status" />
          <FunctionField
            label="Interview"
            render={(r) => {
              const screenRequestsRecord = { ...r.assignment, assignment_requests: [r] };
              return <ScreenRequestsField record={screenRequestsRecord} />;
            }}
          />
          <FunctionField
            label="Submitted To VMS"
            render={(v) => (
              <BooleanField record={{ submitted: !!v.vms_application_status }} source="submitted" />
            )}
          />
        </Datagrid>
      </ReferenceManyField>
    </SimpleShowLayout>
  );
};

export default React.memo(PermanentPlacementApplicationsTab);
